import ActionTypes from '../constants/ActionTypes'; 

const initialState = {
    loading: false,
    data: {},
    error: null,
};

const measureReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.MEASURE_EDIT_REQUEST:
            return { ...state, loading: true };
        case ActionTypes.MEASURE_EDIT_SUCCESS:
            return { ...state, loading: false, data: action.payload};
        case ActionTypes.MEASURE_EDIT_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case ActionTypes.REGISTER_EDIT_MEASURE_REQUEST:
            return { ...state, loading: true, error: null};
        case ActionTypes.REGISTER_EDIT_MEASURE_SUCCESS:
            return { ...state, loading: false, message: action.payload, error: null };
        case ActionTypes.REGISTER_EDIT_MEASURE_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default measureReducer;
